export default __webpack_public_path__ + "static/media/001-highway-1.2725d706.png";